import NewsroomListing from "./NewsroomListing.jsx";
import { PRESS_RELEASES } from "../data/News.js";

/**
 * ASSOCHAM — Newsroom / Press Release
 * Official statements, announcements and communiqués.
 */
export default function PressRelease() {
  return (
    <NewsroomListing
      // eyebrow="Official Communiqués"
      titleA="Press"
      titleB="Releases"
      // description="Every official word from the chamber — statements on policy, signed partnerships, conclave outcomes and research launches, straight from the ASSOCHAM media desk in New Delhi."
      items={PRESS_RELEASES}
      // listTitle="Press Release"
      showSource={false}
    />
  );
}
